import { Channel } from "@/config/channel"
import { triggerSurvey, TriggerType } from "./survey-utils"

export const SandsivSurveyIdPS = {
  ThankYouPage: 15,
  Home: 18,
  Bonus: 22,
  PdvSignup: 26,
  TaxCode: 24,
  ResidenceAddress: 27,
  Contacts: 28,
  AccessData: 29,
  SelectDocument: 30,
  DocumentData: 31,
  TopupLimits: 32,
  TermsAndConditions: 33,
  RecapOcr: 54,
} as const

type SandsivSurveyIdPSItaType =
  (typeof SandsivSurveyIdPS)[keyof typeof SandsivSurveyIdPS]

const apiUrl = "https://pokerstars-survey.sandsiv.com"

export function triggerSurveyPS(
  surveyId: SandsivSurveyIdPSItaType,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
  accountId?: string | null,
) {
  return triggerSurvey(
    apiUrl,
    surveyId,
    channel,
    triggerType,
    ipAddress,
    accountId,
  )
}

export function triggerSurveyBasedOnPathnamePS(
  pathname: string,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
) {
  const surveyId = getSurveyId(pathname)
  if (surveyId == null) return false
  return triggerSurvey(apiUrl, surveyId, channel, triggerType, ipAddress)
}

function getSurveyId(pathname: string): SandsivSurveyIdPSItaType | null {
  switch (pathname) {
    case "/":
      return SandsivSurveyIdPS.Home
    case "/codice-fiscale":
      return SandsivSurveyIdPS.TaxCode
    case "/indirizzo-residenza":
      return SandsivSurveyIdPS.ResidenceAddress
    case "/contatti":
      return SandsivSurveyIdPS.Contacts
    case "/dati-di-accesso":
      return SandsivSurveyIdPS.AccessData
    case "/bonus":
      return SandsivSurveyIdPS.Bonus
    case "/dati-documento":
      return SandsivSurveyIdPS.DocumentData
    case "/limiti-ricarica":
      return SandsivSurveyIdPS.TopupLimits
    case "/riepilogo-dati-ocr":
      return SandsivSurveyIdPS.RecapOcr
    case "/termini-e-condizioni":
    case "/termini-e-condizioni-ocr":
      return SandsivSurveyIdPS.TermsAndConditions
    case "/registrazione-pdv":
      return SandsivSurveyIdPS.PdvSignup
    case "/seleziona-documento/cliente":
      return SandsivSurveyIdPS.SelectDocument
    default:
      return null
  }
}
